const TARGET_PRODUCT_IDS = [9255983874236,9313755365564,9313755103420,9313754841276,9313752711356, 9463978426556]; // Add more IDs here

function getUpcartShadowRoot() {
  const upcartEl = document.querySelector("#upCart");
  return upcartEl ? upcartEl.shadowRoot : null;
}

function checkCartForTargetProduct({ cart }) {
  const matchedItems = cart.items.filter((item) =>
    TARGET_PRODUCT_IDS.includes(item.productId)
  );

  const hasTargetProduct = matchedItems.length > 0;

  if (hasTargetProduct) {
    matchedItems.forEach((item) => {
      console.log(`Product ${item.productId} found in cart!`);
    });
  }

  return hasTargetProduct;
}

function updateCheckoutButtonColor({ shadowRoot, hasTargetProduct }) {
  const checkoutBtn = shadowRoot.querySelector(".upcart-checkout-button");
  if (!checkoutBtn) return;

  const color = hasTargetProduct ? "#0B0C54" : "#AFD74B";
  console.log(`[UpcartChecker] Checkout button color set to ${color}`);
  checkoutBtn.style.backgroundColor = color;

  // Remove old listeners by cloning the node
  const newBtn = checkoutBtn.cloneNode(true);
  checkoutBtn.parentNode.replaceChild(newBtn, checkoutBtn);

  newBtn.addEventListener("mouseenter", () => {
    const hoverColor = hasTargetProduct ? "#FFFFFF" : "#000000";
    newBtn.style.setProperty("color", hoverColor, "important");
  });
  newBtn.addEventListener("mouseleave", () => {
    newBtn.style.removeProperty("color");
  });
}

function injectShadowStyles({ shadowRoot }) {
  if (shadowRoot.querySelector("#upcart-checker-styles")) return;

  const style = document.createElement("style");
  style.id = "upcart-checker-styles";
  style.textContent = `
    .hide-announcement [data-upcart-chunk="announcement"] {
      display: none !important;
    }
    #discount-unlocked-label {
      color: #FFFFFF;
      font-weight: bold;
      font-size: 16px;
      text-align: center;
      padding: 8px 0 0 0;
    }
  `;
  shadowRoot.appendChild(style);
  console.log("[UpcartChecker] Shadow styles injected");
}

function updateDiscountLabel({ shadowRoot, hasTargetProduct }) {
  const announcementBar = shadowRoot.querySelector(
    ".upcart-internal-announcement.upcart-public-announcement"
  );
  if (!announcementBar) return;

  injectShadowStyles({ shadowRoot });

  let discountLabel = shadowRoot.querySelector("#discount-unlocked-label");

  if (hasTargetProduct) {
    announcementBar.classList.add("hide-announcement");
    announcementBar.style.backgroundColor = "#0B0C54";

    if (!discountLabel) {
      discountLabel = document.createElement("div");
      discountLabel.id = "discount-unlocked-label";
      discountLabel.textContent = "Discount Unlocked 🔓🔥";
      announcementBar.appendChild(discountLabel);
      console.log("[UpcartChecker] Discount label created");
    }

    discountLabel.style.display = "block";
  } else {
    announcementBar.classList.remove("hide-announcement");
    announcementBar.style.backgroundColor = "#AFD74B";

    if (discountLabel) {
      discountLabel.style.display = "none";
    }
  }
}

function initUpcartCartChecker() {
  if (typeof upcartGetCart !== "function") {
    setTimeout(initUpcartCartChecker, 500);
    return;
  }

  const handleCartChange = () => {
    setTimeout(() => {
      const cart = upcartGetCart();
      console.log("[UpcartChecker] Cart fetched:", cart);
      const hasTargetProduct = checkCartForTargetProduct({ cart });
      const shadowRoot = getUpcartShadowRoot();
      if (shadowRoot) {
        updateCheckoutButtonColor({ shadowRoot, hasTargetProduct });
        updateDiscountLabel({ shadowRoot, hasTargetProduct });
      }
    }, 500);
  };

  upcartOnCartOpened = handleCartChange;
  upcartOnCartUpdated = handleCartChange;
}

initUpcartCartChecker();